export default function useAuth() {
    const queryClient = ReactQuery.useQueryClient()
    const { data, isLoading, isSuccess } = ReactQuery.useQuery({
        queryKey: ['auth'],
        queryFn: () => storageGet('userWidgetData'),
        staleTime: Infinity,
        gcTime: Infinity,
    })

    const { data: permissions } = ReactQuery.useQuery({
        queryKey: ['auth', 'permissions'],
        queryFn: () => authAction.getPermissions(),
        staleTime: Infinity,
        gcTime: Infinity,
        enabled: !!data
    })

    React.useEffect(() => {
        const dispose = storageListen('userWidgetData', (data) => queryClient.setQueryData(['auth'], data))

        return () => {
            dispose()
        }
    }, [])

    return { 
        data, 
        isLoading,
        isLoaded: isSuccess,
        isLoggedIn: !!data && 'token' in data,
        canModifyPdf: data && permissions && permissions.includes('CAN_MODIFY_PDF'),
    }
}
